export const COOKIES_CONSTANTS = {
  ACCESS_TOKEN_KEY: "accessToken",
  AUTH0_USER_KEY: "auth0User",
};
